var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/women_unselected.cbf84d81.png","uri@2x": __webpack_public_path__ + "static/media/women_unselected.08ff45e3.png","uri@3x": __webpack_public_path__ + "static/media/women_unselected.7a8af539.png",
    width: 24,
    height: 28
});